import React from 'react';
import { Link } from 'react-router-dom';

function PrimaryNav({ items, activeHref }) {
    if (!items?.length) {
        return null;
    }

    return (
        <div
            className="hidden xl:flex flex-1 items-center justify-center xl:space-x-4"
            data-testid="site-header-desktop-navigation"
        >
            {items.map((item) => (
                <Link
                    key={item.id || item.href}
                    to={item.href}
                    aria-current={activeHref === item.href ? 'page' : undefined}
                    className={`px-3 py-2 rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-200/70 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 ${
                        activeHref === item.href ? 'bg-[var(--primary)]/30 text-white' : 'text-gray-300 hover:bg-white/10'
                    }`}
                >
                    <item.icon className="w-4 h-4 mr-2 inline" aria-hidden="true" />
                    {item.name}
                </Link>
            ))}
        </div>
    );
}

export default PrimaryNav;
